//@flow
import * as React from 'react';
import Modal from 'react-modal';
import './styles/index.css';
import PageRouter from 'pages/PageRouter';
import Localized from 'components/Localized';
import {Layout} from 'components/Layout';
import Session from 'components/Session';

Modal.setAppElement('#root');

export default function App(): React.Element<any> {
  return (
    <Localized>
      <Layout>
        <Session>
          <PageRouter />
        </Session>
      </Layout>
    </Localized>
  );
}
